// Global event bus
//
// https://medium.com/@andrejsabrickis/https-medium-com-andrejsabrickis-create-simple-eventbus-to-communicate-between-vue-js-components-cdc11cd59860
//
// Don't use this from components, rather use the EventBus Mixin

import Vue from 'vue'

export default new Vue()
